/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coins_Pack_BarrelInputs */

const en_coins_pack_barrel = /** @type {(inputs: Coins_Pack_BarrelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barrel of Coins`)
};

const ar_coins_pack_barrel = /** @type {(inputs: Coins_Pack_BarrelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برميل من العملات`)
};

const de_coins_pack_barrel = /** @type {(inputs: Coins_Pack_BarrelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Fass Münzen`)
};

const es_coins_pack_barrel = /** @type {(inputs: Coins_Pack_BarrelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barril de monedas`)
};

const fr_coins_pack_barrel = /** @type {(inputs: Coins_Pack_BarrelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un tonneau de Pièces`)
};

const it_coins_pack_barrel = /** @type {(inputs: Coins_Pack_BarrelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barile di Monete`)
};

const ja_coins_pack_barrel = /** @type {(inputs: Coins_Pack_BarrelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`樽一杯のコイン`)
};

const ko_coins_pack_barrel = /** @type {(inputs: Coins_Pack_BarrelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코인 한 통`)
};

const pt_br_coins_pack_barrel = /** @type {(inputs: Coins_Pack_BarrelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barril de moedas`)
};

const ru_coins_pack_barrel = /** @type {(inputs: Coins_Pack_BarrelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бочка монет`)
};

const th_coins_pack_barrel = /** @type {(inputs: Coins_Pack_BarrelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เหรียญหนึ่งถัง`)
};

const tr_coins_pack_barrel = /** @type {(inputs: Coins_Pack_BarrelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir Varil Jeton`)
};

const zh_cn_coins_pack_barrel = /** @type {(inputs: Coins_Pack_BarrelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一桶金币`)
};

const zh_tw_coins_pack_barrel = /** @type {(inputs: Coins_Pack_BarrelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一桶金幣`)
};

/**
* | output |
* | --- |
* | "Barrel of Coins" |
*
* @param {Coins_Pack_BarrelInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const coins_pack_barrel = /** @type {((inputs?: Coins_Pack_BarrelInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coins_Pack_BarrelInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coins_pack_barrel(inputs)
	if (locale === "ar") return ar_coins_pack_barrel(inputs)
	if (locale === "de") return de_coins_pack_barrel(inputs)
	if (locale === "es") return es_coins_pack_barrel(inputs)
	if (locale === "fr") return fr_coins_pack_barrel(inputs)
	if (locale === "it") return it_coins_pack_barrel(inputs)
	if (locale === "ja") return ja_coins_pack_barrel(inputs)
	if (locale === "ko") return ko_coins_pack_barrel(inputs)
	if (locale === "pt_br") return pt_br_coins_pack_barrel(inputs)
	if (locale === "ru") return ru_coins_pack_barrel(inputs)
	if (locale === "th") return th_coins_pack_barrel(inputs)
	if (locale === "tr") return tr_coins_pack_barrel(inputs)
	if (locale === "zh_cn") return zh_cn_coins_pack_barrel(inputs)
	return zh_tw_coins_pack_barrel(inputs)
});